export const fetchTicker = async () => {
    const apiHost = document.body.dataset.apiHost || 'api.mesonet.org'
    const url = `https://${apiHost}/v2/ticker/entries/latest`
    const response = await fetch(url)
    const json: TickerAPIResponse = await response.json()

    const data = json.data
    const date = new Date(data.date)
    const title = data.title.trim() || null

    const output: TickerResponse = {
        date,
        title,
    }

    return output
}

export const renderTicker = (
    element: HTMLAnchorElement,
    data: TickerResponse,
) => {
    const dateFormatted = data.date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    })
    if (element.dataset.tickerLinkStyle === 'date-only' || !data.title) {
        element.textContent = dateFormatted
        element.ariaLabel = `OCS/Mesonet Ticker for ${dateFormatted}`
    } else {
        element.textContent = `${dateFormatted}: ${data.title}`
        element.ariaLabel = `OCS/Mesonet Ticker for ${dateFormatted}: ${data.title}`
    }
}

export const load = async () => {
    const data = await fetchTicker()
    const elements = document.querySelectorAll(
        'a.ticker-link',
    ) as NodeListOf<HTMLAnchorElement>

    elements.forEach((element) => renderTicker(element, data))
}

load()
